<template>
  <div class="form-group row">
    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Número Protocolo:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <the-mask :key="key" :mask="['##/######/####']" type="text" class="form-control" v-model="filtroProcesso.numeroProcesso"/>
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Município:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroProcesso.cidade">
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Interessado:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroProcesso.interessados">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Remetente:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroProcesso.remetente">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Assunto:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroProcesso.assunto">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Listar armazenados:</label>
      </div>
      <div class="col-sm-4 mb-3">
        <input type="checkbox" v-model="filtroProcesso.armazenado">
      </div>
      <div class="col-sm-2 text-sm-right">
        <label>Listar arquivados:</label>
      </div>
      <div class="col-sm-4 mb-3">
        <input type="checkbox" v-model="filtroProcesso.arquivado">
      </div>
      <div class="col-sm-2 text-sm-right">
        <label>Listar anexados:</label>
      </div>
      <div class="col-sm-4 mb-3">
        <input type="checkbox" v-model="filtroProcesso.anexado">
      </div>
      <div class="col-sm-2 text-sm-right">
        <label>Listar eliminados:</label>
      </div>
      <div class="col-sm-4 mb-3">
        <input type="checkbox" v-model="filtroProcesso.eliminado">
      </div>
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar(1)"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar()"> Limpar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import VirtusService from '@/services/VirtusService'

export default {
  name: 'filtroPesquisaMeus',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      key: true,
      filtroProcesso: {
        numeroProcesso: '',
        remetente: '',
        cidade: '',
        assunto: '',
        interessados: '',
        offset: 1,
        range: this.rowsNumber,
        idDepartamento: '',
        armazenado: false,
        arquivado: false,
        anexado: false,
        eliminado: false,
        apensado: false,
        emTramite: false,
        consulta: 'meus'
      }
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina, action) => {
      this.trocaDePagina(numeroPagina, action)
    })

    this.service = new VirtusService()
    this.pesquisar()
  },

  methods: {
    pesquisar (page = 1, action) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtroProcesso.tipoIdentificador = 'LOGIN'
      this.filtroProcesso.identificador = dadosSessao.sessao.login
      this.filtroProcesso.tipoIdentificadorPai = 'ID'
      this.filtroProcesso.identificadorPai = dadosSessao.sessao.idDepartamento
      this.filtroProcesso.offset = page

      this.service.consultaMeus(this.filtroProcesso).then(res => {
        eventBus.$emit(this.eventBusDataName, res, action)
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtroProcesso.numeroProcesso = ''
      this.filtroProcesso.remetente = ''
      this.filtroProcesso.cidade = ''
      this.filtroProcesso.assunto = ''
      this.filtroProcesso.interessados = ''
      this.filtroProcesso.armazenado = false
      this.filtroProcesso.arquivado = false
      this.filtroProcesso.anexado = false
      this.filtroProcesso.eliminado = false
      this.filtroProcesso.apensado = false

      this.key = !this.key
      this.pesquisar(1, 'RESET_SELECTED')
    },

    trocaDePagina (numeroPagina, action) {
      this.pesquisar(numeroPagina, action)
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}
</style>
